import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default theme => ({
  '& .w5-popover': _objectSpread(_objectSpread({
    position: 'relative',
    display: 'none',
    maxWidth: '150px',
    backgroundColor: theme.colors.actionMinor[50],
    color: theme.colors.utility.textSecondary,
    borderRadius: '3px',
    padding: '20px',
    zIndex: '1',
    boxShadow: '0 3px 9px 0 rgba(0, 0, 0, 0.25)'
  }, theme.typography.defaultText), {}, {
    '& .w5-popover-arrow': {
      position: 'absolute',
      width: '6px',
      height: '6px',
      zIndex: '-1',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '6px',
        height: '6px',
        zIndex: '-1',
        borderRadius: '1px',
        transform: 'rotate(45deg)',
        background: theme.colors.actionMinor[50]
      }
    },
    '&[data-popper-placement=top] > .w5-popover-arrow': {
      bottom: '-3px'
    },
    '&[data-popper-placement=top-start] > .w5-popover-arrow': {
      bottom: '-3px',
      '&:before': {
        left: '-5px'
      }
    },
    '&[data-popper-placement=top-end] > .w5-popover-arrow': {
      bottom: '-3px',
      '&:before': {
        right: '-5px'
      }
    },
    '&[data-popper-placement=bottom] > .w5-popover-arrow': {
      top: '-3px'
    },
    '&[data-popper-placement=bottom-start] > .w5-popover-arrow': {
      top: '-3px',
      '&:before': {
        left: '-5px'
      }
    },
    '&[data-popper-placement=bottom-end] > .w5-popover-arrow': {
      top: '-3px',
      '&:before': {
        right: '-5px'
      }
    },
    '&[data-popper-placement=left] > .w5-popover-arrow': {
      right: '-3px'
    },
    '&[data-popper-placement=left-start] > .w5-popover-arrow': {
      right: '-3px'
    },
    '&[data-popper-placement=left-end] > .w5-popover-arrow': {
      right: '-3px'
    },
    '&[data-popper-placement=right] > .w5-popover-arrow': {
      left: '-3px'
    },
    '&[data-popper-placement=right-start] > .w5-popover-arrow': {
      left: '-3px'
    },
    '&[data-popper-placement=right-end] > .w5-popover-arrow': {
      left: '-3px'
    }
  })
});